import { render, staticRenderFns } from "./InventoryInBatchUpdate.vue?vue&type=template&id=23236729&scoped=true&"
import script from "./InventoryInBatchUpdate.vue?vue&type=script&lang=js&"
export * from "./InventoryInBatchUpdate.vue?vue&type=script&lang=js&"
import style0 from "./InventoryInBatchUpdate.vue?vue&type=style&index=0&id=23236729&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23236729",
  null
  
)

export default component.exports